export default __webpack_public_path__ + "static/media/promocionAlarma3.fab3d2ec.png";